export enum COLOR_THEME {
    SENSOR = '#505bda',
    ARDUINO_START_BLOCK = '#b063c5',
    COMPONENTS = '#512c62',
    ARDUINO = '#b063c5',
    DATA = '#ffaac3',
    VALUES = '#505bda',
    CONTROL = '#b063c5',
    BLUE = '#3399FF',
    PURPLE = '#B266FF',
    PINK = 'CC00CC',
    YELLOW = 'FFCC33',
    ORANGE = 'FFA500',
    GREEN = '3CB371',
    DARK_ORANGE = 'FF4500',
}
